import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ucwords } from '../helper';
import * as actions from '../actions';
import * as c from '../constant';

function BusinessActivityModal({
  formData,
  setFormData,
  getBusinessNaturesList,
  businessNaturesList,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  businessActivityInfo,
  closeUpdateModal,
  handleOnUpdate,
}) {
  const validateForm = useFormValidator(formData, {
    business_nature_id: 'required',
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
  });

  const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, '');

  useEffect(() => {
    getBusinessNaturesList();
    getBusinessLinesList();
    if (
      !_.isEmpty(_.get(businessActivityInfo, 'attributes.business_line_id'))
    ) {
      getNecessaryFieldsList({
        business_line_id: _.get(
          businessActivityInfo,
          'attributes.business_line_id'
        ),
      });
    }
  }, []);

  const formatNumberWithCommas = value => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  useEffect(() => {
    let keyValues = [];
    keyValues = Object.entries(
      _.get(businessActivityInfo, 'attributes.details') || ''
    ).map(([key, value]) => ({
      [key]: value.toString() || '',
    }));

    let finalObject = {};
    const badCallback = (a, i) => Object.assign(a, i);
    finalObject = keyValues.reduce(badCallback, {});

    setFormData({
      ...formData,
      ...finalObject,
      business_line_id: +_.get(
        businessActivityInfo,
        'attributes.business_line_id'
      ),
      business_nature_id: +_.get(
        businessActivityInfo,
        'attributes.business_nature_id'
      ),
      capital_amount: formatNumberWithCommas(
        _.get(businessActivityInfo, 'attributes.capital_amount')
      ),
      gross_amount: formatNumberWithCommas(
        _.get(businessActivityInfo, 'attributes.gross_amount')
      ),
    });
  }, []);

  // select nature
  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
  };

  const selectBusinessNatureId = businessNaturesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessNatureValue =
    selectBusinessNatureId.find(
      item => +_.get(formData, 'business_nature_id') === +item.id
    ) || '';

  // select line
  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNecessaryFieldsList({ business_line_id: e.value });
  };

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessLineValue =
    selectBusinessLineId.find(
      item => +_.get(formData, 'business_line_id') === +item.id
    ) || '';

  // select necessary field
  const handleOfficeTypeDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleChangeCapitalAmount = event =>
    setFormData({
      capital_amount: addCommas(removeNonNumeric(event.target.value)),
    });

  // const handleChangeGrossAmount = event =>
  //   setFormData({
  //     gross_amount: addCommas(removeNonNumeric(event.target.value)),
  //   });

  const handleOnChange = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  // const onBlurDecimal = (e) => {
  //   setFormData({
  //     ...formData,
  //     [_.get(e, "target.name")]: parseFloat(_.get(e, "target.value")),
  //   });
  // };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <div className="border rounded my-2">
      <div className="row p-2">
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Line of Business : &nbsp;
          </label>
          <b>
            {_.get(
              businessActivityInfo,
              'attributes.initial_data.line_of_business'
            )}
          </b>
        </div>
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Number of Units : &nbsp;
          </label>
          <b>
            {_.get(businessActivityInfo, 'attributes.initial_data.no_of_units')
              ? parseFloat(
                  _.get(
                    businessActivityInfo,
                    'attributes.initial_data.no_of_units'
                  ) || 0,
                  10
                ).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : '0.00'}
          </b>
        </div>
        <div className="col-4 my-2">
          <label className="text-primary font-weight-bold">
            Service : &nbsp;
          </label>
          <b>
            {_.get(businessActivityInfo, 'attributes.initial_data.service')}
          </b>
        </div>
        <div className="col-12 form-group">
          <label className="form-label">
            Business Nature: {validateForm.renderMessage('business_nature_id')}
          </label>
          <Select
            options={selectBusinessNatureId}
            placeholder="Select Business Nature"
            value={findBusinessNatureValue}
            onChange={handleNatureDropDownChange('business_nature_id')}
          />
        </div>
        <div className="col-12 form-group">
          <label className="form-label">
            Business Line: {validateForm.renderMessage('business_line_id')}
          </label>
          <Select
            options={selectBusinessLineId}
            placeholder="Select Business Line"
            value={findBusinessLineValue}
            onChange={handleLineDropDownChange('business_line_id')}
          />
        </div>
        <div className="col-12 form-group">
          <label className="form-label">
            Capital Amount: {validateForm.renderMessage('capital_amount')}
          </label>
          <input
            className="form-control"
            type="text"
            name="capital_amount"
            onChange={handleChangeCapitalAmount}
            // onChange={handleOnChange('capital_amount')}
            value={_.get(formData, 'capital_amount') || ''}
            // onBlur={onBlurDecimal}
          />
        </div>
        {/* <div className="col-12 form-group">
          <label className="form-label">
            Gross Amount: {validateForm.renderMessage('gross_amount')}
          </label>
          <input
            className="form-control"
            type="text"
            name="gross_amount"
            // onChange={handleOnChange('gross_amount')}
            onInput={handleChangeGrossAmount}
            value={_.get(formData, 'gross_amount')}
            // onBlur={onBlurDecimal}
          />
        </div> */}

        <div className="col-12 form-group">
          {necessaryFieldsList.map(item => {
            return (
              <div>
                <div>
                  {_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}{' '}
                      </label>
                      <Select
                        onChange={handleOfficeTypeDropDownChange(
                          _.get(item, 'multiplier')
                        )}
                        options={selectOptions(_.get(item, 'options'))}
                        value={
                          selectOptions(_.get(item, 'options')).find(
                            x =>
                              _.get(formData, _.get(item, 'multiplier')) ===
                              _.get(x, 'value')
                          ) || ''
                        }
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group">
                  {!_.get(item, 'options') ? (
                    <div>
                      <label className="form-label">
                        {ucwords(_.get(item, 'multiplier').replace(/_/g, ' '))}{' '}
                      </label>
                      <input
                        className="form-control"
                        name={_.get(item, 'label')}
                        id={_.get(item, 'label')}
                        onChange={handleOnChange(_.get(item, 'multiplier'))}
                        value={_.get(formData, _.get(item, 'multiplier'))}
                        required
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-flex justify-content-end pb-3">
        <button
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          onClick={handleOnUpdate(formData)}
        >
          <span className="font-weight-bold">Submit</span>
        </button>
        <button
          type="button"
          onClick={() => closeUpdateModal()}
          className="mt-3 btn btn-dark mr-2"
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
    </div>
  );
}

BusinessActivityModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  businessActivityInfo: PropTypes.instanceOf(Object).isRequired,
  closeUpdateModal: PropTypes.instanceOf(Function).isRequired,
  handleOnUpdate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BusinessActivityModal);
